var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Row',[_c('Col',{attrs:{"span":"24"}},[_c('MyTable',{ref:"myhistories",on:{"changepage":_vm.changePage,"ontimechange":_vm.ontimechanged}})],1)],1),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }